import { useState } from "react";
import { Link } from "react-router-dom";
import { joinClassNames } from "helpers/joinClassNames";
import { Icon } from "components/Icon";
import { ICONS } from "constants/icons";
import { ROUTES } from "constants/navigation";

export const MobileSolutionsDropdown = ({ 
    title = "Solutions", 
    items = [], 
    variant = "header",
    onItemClick
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const basePath = ROUTES.solutions.path;

    return (
        <li 
            className={joinClassNames(
                "mobile-dropdown",
                `mobile-dropdown--${variant}`,
                isOpen && "mobile-dropdown-open"
            )}
        >
            <button
                type="button"
                className="mobile-dropdown-trigger"
                onClick={() => setIsOpen((prev) => !prev)}
            >
                <span className="mobile-dropdown-title">{title}</span>
                <div className="mobile-dropdown-arrow">
                    <Icon icon={ICONS.selectArrow} />
                </div>
            </button>

            {isOpen && (
                <div className="mobile-dropdown-panel">
                    {items.map((item, index) => {
                        let rawPath = item.path || "";

                        if (rawPath.startsWith("/solutions/")) {
                            rawPath = rawPath.replace("/solutions/", "");
                        } else if (rawPath.startsWith("solutions/")) {
                            rawPath = rawPath.replace("solutions/", "");
                        }

                        let targetPath;
                        if (rawPath === "/solutions" || rawPath === "solutions" || rawPath === "") {
                            targetPath = basePath;
                        } else {
                            const cleanSubPath = rawPath.replace(/^\//, "");
                            targetPath = `${basePath}/${cleanSubPath}`;
                        }

                        return (
                            <Link
                                key={item.id || item.path || index}
                                to={`${targetPath}#page`}
                                className="mobile-dropdown-item"
                                onClick={() => {
                                    setIsOpen(false);
                                    if (onItemClick) onItemClick();
                                }}
                            >
                                <span className="mobile-dropdown-item-text">
                                    {item.label}
                                </span>
                            </Link>
                        );
                    })}
                </div>
            )}
        </li>
    );
};